// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qal-","colMin":"styles_colMin__nCz__"};